export const CrownV2 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
      <path
        d="M5.70842 0.17052C5.81718 -0.0569277 6.14097 -0.056928 6.24972 0.17052L8.50349 4.88395C8.59579 5.07697 8.85469 5.1141 8.99751 4.9548L11.4344 2.23668C11.6325 2.01572 11.9969 2.18579 11.9548 2.47954L10.7731 10.7171C10.7519 10.8649 10.6254 10.9745 10.4761 10.9745H1.482C1.33277 10.9745 1.20623 10.8649 1.18504 10.7171L0.00337762 2.47954C-0.03876 2.18579 0.325611 2.01572 0.523709 2.23668L2.96063 4.9548C3.10346 5.1141 3.36236 5.07697 3.45465 4.88395L5.70842 0.17052Z"
        fill="#F5B53D"
      />
    </svg>
  );
};
